"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigGate = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const runtime_config_1 = require("./runtime-config");
const LoadingScreen_1 = require("../../components/loader/LoadingScreen");
const ConfigGate = ({ children, }) => {
    const [status, setStatus] = (0, react_1.useState)('loading');
    const [error, setError] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        (0, runtime_config_1.loadRuntimeConfig)()
            .then(() => setStatus('ready'))
            .catch((err) => {
            setStatus('error');
            setError(err);
            console.error('Failed to load runtime config:', err);
        });
    }, []);
    if (status === 'loading') {
        return (0, jsx_runtime_1.jsx)(LoadingScreen_1.LoadingScreen, {});
    }
    if (status === 'error') {
        return ((0, jsx_runtime_1.jsxs)("div", { className: "config-error-screen", children: [(0, jsx_runtime_1.jsx)("h2", { children: "Error de configuraci\u00F3n" }), (0, jsx_runtime_1.jsx)("p", { children: error?.message || 'Error desconocido al cargar la configuración' }), (0, jsx_runtime_1.jsx)("button", { onClick: () => window.location.reload(), children: "Reintentar" })] }));
    }
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children });
};
exports.ConfigGate = ConfigGate;
